let decoration, base;
const defaults = [
  'eventCategory',
  'eventAction',
  'eventLabel',
  'eventValue',
  'fieldsObject'
];

module.exports = function (d, b) {
  if (true) {
    base = b;
    decoration = d;

    const extension = {
      trackEvent: function (params) {
        const defaultParams = { hitType: 'event' };
        _.each(defaults, function (key) {
          if (d[key]) defaultParams[key] = d[key];
        });

        INKIVE.C.IS_DEV || (typeof ga !== 'undefined' && ga('send', _.extend(defaultParams, params)));
        // INKIVE.C.IS_DEV && console.log(_.extend(defaultParams, params));
      }
    };

    _.each(decoration, processDecoratorMethod, extension);
    return b.extend
      ? b.extend(extension)
      : _.extend({}, b, extension);
  }

  return b;
};

function processDecoratorMethod (trackMethod, key) {
  if (_.contains(defaults, key) || !trackMethod) return;

  if (!_.isFunction(trackMethod)) {
    const trackObject = decoration[key];
    trackMethod = function () {
      this.trackEvent(trackObject);
    };
  }

  this[key] = _.partial(decoratedWrapper, trackMethod, base.prototype[key]);
}

function decoratedWrapper (trackMethod, baseFunc) {
  const args = _.rest(arguments, 2);

  trackMethod.apply(this, args);
  baseFunc.apply(this, args);
}
